/*
 Copyright 2016 OpenMarket Ltd

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require("matrix-js-sdk");

var _GetFileCategory = require("../../../utils/GetFileCategory");

var _DownloadUtils = require("../../../DownloadUtils");

var _DownloadUtils2 = _interopRequireDefault(_DownloadUtils);

var _languageHandler = require("../../../languageHandler");

var _MFileBody = require("./MFileBody");

var _MFileBody2 = _interopRequireDefault(_MFileBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MFileTypeBody = function (_React$Component) {
    (0, _inherits3.default)(MFileTypeBody, _React$Component);

    function MFileTypeBody() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MFileTypeBody);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MFileTypeBody.__proto__ || (0, _getPrototypeOf2.default)(MFileTypeBody)).call.apply(_ref, [this].concat(args))), _this), _this.downloadFile = function (e) {
            var mxEvent = _this.props.mxEvent;

            var content = mxEvent.getContent();
            var fileName = content.body && content.body.length > 0 ? content.body : (0, _languageHandler._t)("Attachment");
            var contentUrl = _this.getContentUrl();

            e.preventDefault();
            e.stopPropagation();
            console.log("Downloading " + fileType + " as blob (unencrypted)");
            _DownloadUtils2.default.download(contentUrl, fileName);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MFileTypeBody, [{
        key: "getIcon",
        value: function getIcon() {
            var mxEvent = this.props.mxEvent;

            var content = mxEvent.getContent();
            var fileType = content.info ? content.info.mimetype : "application/octet-stream";
            var fileCategory = (0, _GetFileCategory.getFileCategory)(fileType);

            if (fileCategory === "media") {
                return require("../../../../res/img/filetype-media.svg");
            }

            if (fileCategory === "image") {
                var pixelRatio = window.devicePixelRatio;
                var thumbWidth = Math.round(32 * pixelRatio);
                var thumbHeight = Math.round(32 * pixelRatio);
                return this.context.matrixClient.mxcUrlToHttp(content.url, thumbWidth, thumbHeight, "crop");
            }

            if (fileCategory === "spreadsheet") {
                return require("../../../../res/img/filetype-excel.svg");
            }

            if (fileCategory === "archive") {
                return require("../../../../res/img/filetype-zip.svg");
            }

            if (fileCategory === "document") {
                return require("../../../../res/img/filetype-word.svg");
            }

            if (fileCategory === "pdf") {
                return require("../../../../res/img/filetype-pdf.svg");
            }

            return require("../../../../res/img/filetype-unknown.svg");
        }
    }, {
        key: "getContentUrl",
        value: function getContentUrl() {
            var content = this.props.mxEvent.getContent();
            return this.context.matrixClient.mxcUrlToHttp(content.url);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                tileShape = _props.tileShape,
                mxEvent = _props.mxEvent;

            if (tileShape !== "file_grid") {
                return _react2.default.createElement(_MFileBody2.default, this.props);
            }

            var content = mxEvent.getContent();
            var fileName = content.body && content.body.length > 0 ? content.body : (0, _languageHandler._t)("Attachment");

            return _react2.default.createElement(
                "a",
                {
                    className: "mx_MFileTypeBody",
                    href: this.getContentUrl(),
                    target: "_blank",
                    rel: "noopener",
                    onClick: this.downloadFile
                },
                _react2.default.createElement("img", { src: this.getIcon(), className: "mx_MFileTypeBody_image" }),
                _react2.default.createElement(_MFileBody2.default, this.props)
            );
        }
    }]);
    return MFileTypeBody;
}(_react2.default.Component);

MFileTypeBody.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient)
};
exports.default = MFileTypeBody;
module.exports = exports["default"];
//# sourceMappingURL=MFileTypeBody.js.map